import { createAction } from "@reduxjs/toolkit";
import { StartEndDates } from "types/dates";
import { RoomFilters } from "types/rooms";

const ROOMS_ACTION = "rooms";

export const roomsActions = {
  getRoomsByProjectRequested: createAction<
    | {
        dates?: StartEndDates;
        filters?: RoomFilters;
        pagination?: {
          page: number;
          perPage: number;
        };
      }
    | undefined
  >(`${ROOMS_ACTION}/getRoomsByProject`),

  getRoomsFiltersByProjectRequested: createAction(
    `${ROOMS_ACTION}/getRoomsFiltersByProject`,
  ),

  getRoomsFiltersByProjectIdInProgress: createAction(
    `${ROOMS_ACTION}/getRoomsFiltersByProjectIdInProgress`,
  ),

  getRoomsFiltersByProjectIdDone: createAction(
    `${ROOMS_ACTION}/getRoomsFiltersByProjectIdDone`,
  ),

  getRoomsByProjectInProgress: createAction(
    `${ROOMS_ACTION}/getRoomsByProjectInProgress`,
  ),
  getRoomsByProjectDone: createAction(`${ROOMS_ACTION}/getRoomsByProjectDone`),
  loadRoomsAnswersEnd: createAction(`${ROOMS_ACTION}/loadRoomsAnswersEnd`),

  getRoomByIdRequested: createAction<string>(
    `${ROOMS_ACTION}/getRoomByIdRequested`,
  ),
  getRoomByIdInProgress: createAction(`${ROOMS_ACTION}/getRoomByIdInProgress`),
  getRoomByIdDone: createAction(`${ROOMS_ACTION}/getRoomByIdDone`),
  getRoomByIdError: createAction<unknown>(`${ROOMS_ACTION}/getRoomByIdError`),
};
